import { Handle, Position } from '@xyflow/react';
import { Stack } from 'new/elements/Stack';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { NodeBox } from '../components/NodeBox';
import { ResourceName } from '../components/ResourceName';
import classes from './QueryResponse.module.scss';
import { MarkdownContent } from 'new/elements/MarkdownContent';
import { ExpandableResult } from 'src/js/components/pipelines/cards/components/ExpandableResult';

interface QueryPromptProps {
  data: any;
}

const options = [
  {
    label: 'Markdown',
    value: 'markdown',
  },
  {
    label: 'Text',
    value: 'text',
  },
];

export const QueryResponse = (props: QueryPromptProps) => {
  const {
    data: { id, origin_node_id },
  } = props;
  const result =
    useSelector((state: any) => state.rag.queryResponse[origin_node_id]?.[id]?.response) || '-';
  const [rewriter, setRewriter] = useState('default');

  const onChangeRewriter = (option) => {
    setRewriter(option.value);
  };

  const onClickDownload = () => {};

  return (
    <>
      <NodeBox hideInfo className={classes.container}>
        <ResourceName {...props} hideActions hideOpenDetail>
          QUERY RESPONSE
        </ResourceName>
        <div className={classes.queryPromptContainer}>
          <Stack marginBlock="8px" gap="8px">
            <NodeBox.Title>Result</NodeBox.Title>
            <ExpandableResult key={result}>
              <Stack className={classes.textarea}>
                <MarkdownContent>{result}</MarkdownContent>
                {/*<textarea className={classes.textarea} readOnly value={result} />*/}
              </Stack>
            </ExpandableResult>
            {/*<NodeBox.Title>Output Format</NodeBox.Title>*/}
            {/*<Select*/}
            {/*  value={rewriter}*/}
            {/*  onChange={onChangeRewriter}*/}
            {/*  className="nodrag"*/}
            {/*  options={options}*/}
            {/*/>*/}
            {/*<Stack justifyContent="flex-start" alignItems="flex-start">*/}
            {/*  <Button*/}
            {/*    onClick={onClickDownload}*/}
            {/*    startIcon={<DownloadIcon />}*/}
            {/*    variant="outlined"*/}
            {/*    size="small">*/}
            {/*    Download*/}
            {/*  </Button>*/}
            {/*</Stack>*/}
          </Stack>
        </div>
      </NodeBox>

      <Handle
        isConnectable={false}
        className={classes.handle}
        type="target"
        position={Position.Left}
        id="left"
      />
    </>
  );
};
